export function getMonthDifference(date1: Date, date2: Date) {
  const yearDiff = date2.getFullYear() - date1.getFullYear();
  const monthDiff = date2.getMonth() - date1.getMonth();

  return yearDiff * 12 + monthDiff;
}
